import { IconChevronUpSmall16, InlineText2 } from '@cian/ui-kit';

import { clsx } from 'clsx';
import { FC } from 'react';

import { ICollapsedButtonProps } from './types';

import styles from './CollapsedButton.css';

export const CollapsedButton: FC<ICollapsedButtonProps> = props => {
  const { isCollapsed, onClick, className, children } = props;

  const text = isCollapsed ? children : 'Скрыть';

  return (
    <div className={clsx(styles['root'], className)} data-testid="collapsed-button" onClick={onClick}>
      <InlineText2 color="primary_100">{text}</InlineText2>
      <span className={clsx(styles['arrow'], { [styles['arrow-collapsed']]: isCollapsed })}>
        <IconChevronUpSmall16 color="primary_100" />
      </span>
    </div>
  );
};

CollapsedButton.displayName = 'CollapsedButton';
